var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 24H28V56H32V40H28V28H32V24ZM32 8H28V12H32V8Z",
    fill: "#00AC41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 28H32V40H42L46 33.98L42 28Z",
    fill: "#009DE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 28H28V40H32V28Z",
    fill: "#006A39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H12L8 18L12 24H28V12ZM52 12H32V24H52L56 18L52 12Z",
    fill: "#009DE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12H28V24H32V12Z",
    fill: "#006A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.e86546400ed275e801eb9da953b1bb0c.svg";
export { ForwardRef as ReactComponent };